import { BaseDto } from '@/shared/dtos/base-dto';
import { CartItem } from '../CartItem';
import { clients } from '../clients';

export class CartDTO extends BaseDto {
  public public_uid!: string;
  public client_id!: number;
  public state!: "current" | "finalized" | string;
  public note!: string;

  public items: CartItem[] = [];
/*
  constructor(raw: any = {}) {
    const normalized = this.normalizeCartDTO(raw);
    this.id = normalized.id;
    this.public_uid = normalized.public_uid;
    this.client_id = normalized.client_id;
    this.state = normalized.state;
    this.note = normalized.note;
    this.createdby = normalized.createdby;
    this.updatedby = normalized.updatedby;
    this.datecreated = normalized.datecreated;
    this.dateupdated = normalized.dateupdated;
  }*/
/*
  public normalizeCartDTO(raw: any): CartDTO {
    // Aseguramos las claves mínimas del DTO; si faltan, ponemos defaults seguros
    return {
      id: Number(raw?.id ?? 0),
      public_uid: String(raw?.public_uid ?? ""),
      client_id: Number(raw?.client_id ?? 0),
      state: (raw?.state ?? "") as CartDTO["state"],
      note: String(raw?.note ?? ""),
      createdby: Number(raw?.createdby ?? 0),
      updatedby: Number(raw?.updatedby ?? 0),
      datecreated: new Date(raw?.datecreated ?? ""),
      dateupdated: new Date(raw?.dateupdated ?? "")
    } as unknown as CartDTO;
  }

  public normalizeClient(raw: any): clients {
    // `clients` es clase; si algo viene malformado, pasamos objeto vacío
    try {
      return new clients(raw ?? {});
    } catch {
      return new clients({});
    }
  }

  public normalizeItem(raw: any): CartItem {
    try {
      return new CartItem(raw ?? {});
    } catch {
      return new CartItem({});
    }
  }*/
}